<template>
	<div class="tabpage">
		<el-tabs v-model="activeName"  @tab-click="handleClick" v-if="tablist.length>1||istabcount">
			<el-tab-pane :label="ite.name" :name="ite.name" v-for="(ite,index) in tablist" :key="ite.l_id">
				<span slot="label">{{ ite.name }} <label v-if="ite.l_tabcount">({{ ite.count }})</label> </span>
				<allcontrol v-if="ite.loaded" :ref="'tabpage_'+item.l_id" :item="ite" style="margin-top:-20px" @allcontrol="allcontrol"></allcontrol>
			</el-tab-pane>
		</el-tabs>
		<div v-else>
			<allcontrol :ref="'tabpage_'+tabitem.l_id" :item="tabitem" style="margin-top:-10px" @allcontrol="allcontrol"></allcontrol>
		</div>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	name:'tabpage',
	components: {
		allcontrol:() => import("@/pages/main/controlcenter.vue") //组件嵌套需要这样引用才可以，不然会报组件注册错误
	},
	props: {
		item: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data(){
		return {
			tablist:[],
			activeName:"",
			activetab:'',
			l_id:'',
			tabpage_lang:{},
			l_mode:'',
			pagesize:200,
			tabitem:{},
			istabcount:false
		};
	},
	mounted() {
		debugger
		import('../../static/' + this.$theme + '/style/tabpage.scss');
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
		//console.log('tabpage加载---'+this.item.l_id+'  '+this.$tool.formatdate());
		this.init();
	},
	methods:{
		init(){
			debugger
			var that=this;
			this.$public.GetLanguageByMode('tabpage',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.tabpage_lang=that.$lang.label.tabpage;
					that.GetTabs();
				}
			});
		},
		GetTabs(){
			var that=this;
			
			this.$apipost.get.GetTabs_Only({l_id:this.l_id}).then(res => {
				//debugger
				if(res!=''){
					if(res.tabs!=undefined){
						res.tabs.forEach(e=>{
							if(that.tabpage_lang[e.name]!=undefined)
								e.name=that.tabpage_lang[e.name];
							e.loaded=false;
						});
						
						if(res.tabs.length>0)
						{
							that.activeName=res.tabs[0].name;
							that.activetab=res.tabs[0].type;
							that.l_mode=res.tabs[0].l_mode;
							res.tabs[0].loaded=true;
							that.tablist=res.tabs;
							if(that.tablist.length==1)
								that.tabitem=res.tabs[0];
							if(that.item.iswin!=undefined)
								that.tabitem.iswin=that.item.iswin;
							//debugger
							if(res.tabs[0].l_tabcount){
								that.istabcount=true;
								that.GetTabDataCount('');
							}
						}
					}
				}
			}).catch(e=>{
				
			});
		},
		handleClick(e){
			//debugger
			this.activetab=this.tablist[parseInt(e.index)].type;
			this.l_mode=this.tablist[parseInt(e.index)].l_mode;
			this.tablist[parseInt(e.index)].loaded=true;
		},
		tabpagerollback(e){
			//debugger
		},
		allcontrol(e){
			//先查找到当前选的是哪个选项卡，再查找到选项卡中的筛选条件
			if(e.event=='settabcount'){//读取选项卡汇总
				//debugger
				this.GetTabDataCount(e.search);
			}
		},
		GetTabDataCount(search) {
			var that = this;
			var tab=this.activetab;
			this.$apipost.get.GetOrderTabCount({l_mode:this.l_mode,search:search,tab:tab}).then(res => {
				//debugger
				if (res.state == '1') {
					for (var i = 0; i < that.tablist.length; i++) {
						if (tab != '历史订单') {
							var countlist = res.countlist[0];
							for (var e in countlist) {
								if (e == that.tablist[i].type) {
									that.tablist[i].count = countlist[e];
									break;
								}
							}
						} else {
							var countlist = res.countlist[0];
							if (countlist[tab] != undefined) {
								that.tablist[i].count = countlist[tab];
								break;
							}
						}
					}
					that.setpagecount();
				}
			});
		},
		//设置分页显示数
		setpagecount() {
			//debugger
			var tabs = this.tablist;
			tabs.forEach(e => {
				if (parseInt(e.count) % this.pagesize == 0) {
					e.pagecount = parseInt(e.count) / this.pagesize;
				} else {
					e.pagecount = parseInt(parseInt(e.count) / this.pagesize) + 1;
				}
			});
		},
		getpagecount(tab){
			var pagecount=1;
			for(var i=0;i<this.tablist.length;i++){
				if(this.tablist[i].type==tab)
				{
					pagecount=this.tablist[i].pagecount;
					break;
				}
			}
			return pagecount;
		}
	}
}
</script>

<style>
</style>
